import { createFeatureSelector, createSelector } from '@ngrx/store';
import { sharedFeatureKey } from 'src/app/shared/selectors';
import { SharedState } from 'src/app/shared/state/shared.state';

export const sharedFeature = createFeatureSelector<SharedState>(sharedFeatureKey);

export const selectConfirmationDialog = createSelector(sharedFeature, (state) => state.confirmationDialog);

export const selectConfirmationDialogResult = createSelector(selectConfirmationDialog, (dialog) => dialog.result);

export const selectConfirmationDialogData = createSelector(selectConfirmationDialog, (dialog) => dialog.data);
